import { Component, Input, OnInit } from '@angular/core';
import { CmsComponent } from '@kion/data-models';
import { CmsConfig } from '../../config/cms.config';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from 'ngx-markdown';

@Component({
  selector: 'kion-cms-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.scss']
})
export class ParagraphComponent implements OnInit {

  @Input() component: CmsComponent;

  readonly project: 'LR' | 'FS' | string;
  content: SafeHtml;

  constructor(
    private cmsConfig: CmsConfig,
    private sanitizer: DomSanitizer,
    private markdownService: MarkdownService
  ) {
    this.project = this.cmsConfig.project;
  }

  ngOnInit(): void {
    this.content = this.sanitizer.bypassSecurityTrustHtml(this.markdownService.compile(this.component.content));
  }

}
